<script>
export default {
  name: 'Image',
}
</script>

<script setup>
import { NodeViewWrapper, nodeViewProps } from "@tiptap/vue-3"
import { PhotoIcon, XMarkIcon } from "@heroicons/vue/24/solid";
import EditImage  from "../../Modals/EditImage.vue"
import EditableNode from "../../Components/EditableNodeWrapper.vue"
import useNodeProps from "@/Composables/useNodeProps"
import ActionButton from "../../../../../Buttons/Action.vue";
import useSearchOrSelectImage from "@/Composables/useSearchOrSelectImage"

const props = defineProps({
  ...nodeViewProps,
})

let { src, href, alt, height, fit, target } = useNodeProps(props)

const { openImageModal } = useSearchOrSelectImage((image) => src.value = image.src)
</script>

<template>
  <node-view-wrapper>
    <EditableNode v-bind="props">
      <template #tools>
        <EditImage
          v-model:href="href"
          v-model:alt="alt"
          v-model:height="height"
          v-model:fit="fit"
          v-model:target="target"
        />
      </template>
      <template #content>
        <div class="flex flex-col sm:gap-4 mb-4">
          <div class="flex w-full justify-center">
            <div class="flex-col w-full">
              <div v-if="src" class="flex mb-4 w-full">
                <div class="relative shadow w-full">
                  <action-button
                    @click="src = null" icon
                    class="absolute -right-3 top-4 bg-white shadow text-red-400 hover:bg-white hover:text-red-500 hover:shadow rounded-full"
                  >
                    <x-mark-icon class="w-4 h-4 bg-white"/>
                  </action-button>
                  <img
                    :src="src"
                    :alt="alt"
                    :style="{ height: height === 'full' ? '100%' : height + 'px' }"
                    :class="['w-full object-' + fit]"
                  />
                </div>
              </div>
              <div v-else class="flex flex-col justify-center items-center mt-2">
                <PhotoIcon class="w-12 h-12 text-gray-300" />
                <p class="mt-1 text-sm text-gray-300">
                  {{ __('Select or upload an image') }}
                </p>
              </div>
              <div class="flex justify-center p-2">
                <action-button secondary @click="openImageModal">
                  {{ __('Select an image') }}
                </action-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </EditableNode>
  </node-view-wrapper>
</template>
